
/**
 * 
 */
class WMUWCPopin {

	/**
	 * 
	 * @type String
	 */
	buttonCloseSelector = '.wmuwc-popin-close';

	/**
	 * 
	 * @type Boolean
	 */
	closeOnClickOutside = true;

	/**
	 * 
	 * @type HTMLElement
	 */
	contentElement = null;

	/**
	 * 
	 * @type String
	 */
	contentSelector = '.wmuwc-popin-content';

	/**
	 * 
	 * @type String
	 */
	displayMode = 'side-right';

	/**
	 * 
	 * @type Boolean
	 */
	enableGlobalControls = true;

	/**
	 * 
	 * @type String
	 */
	id = '';

	/**
	 * 
	 * @type Boolean
	 */
	isCreated = false;

	/**
	 * 
	 * @type Boolean
	 */
	isLoading = false;

	/**
	 * 
	 * @type Boolean
	 */
	isModal = true;

	/**
	 * 
	 * @type Boolean
	 */
	isOpen = false;

	/**
	 * 
	 * @type String
	 */
	loadingClass = 'is-loading';

	/**
	 * 
	 * @type HTMLElement
	 */
	loadingContentElement = null;

	/**
	 * 
	 * @type String
	 */
	loadingContentSelector = '.wmuwc-popin-loader .loading-content';

	/**
	 * 
	 * @type HTMLElement
	 */
	modalElement = null;

	/**
	 * 
	 * @type String
	 */
	modalSelector = '.wmuwc-popin-modal';

	/**
	 * 
	 * @type HTMLElement
	 */
	popinElement = null;

	/**
	 * 
	 * @type String
	 */
	popinSelector = '.wmuwc-popin';

	/**
	 * 
	 * @type String
	 */
	templateId = '';

	/**
	 * 
	 * @type HTMLElement
	 */
	wrapperElement = null;

	/**
	 * 
	 * @type String
	 */
	wrapperSelector = '.wmuwc-popin-wrapper';

	/**
	 * 
	 */
	constructor( args )
	{
		this.closeOnClickOutside = ( args.closeOnClickOutside !== undefined ) ? args.closeOnClickOutside : this.closeOnClickOutside;
		this.displayMode = ( args.displayMode ) ? args.displayMode : this.displayMode;
		this.enableGlobalControls = ( args.enableGlobalControls !== undefined ) ? args.enableGlobalControls : this.enableGlobalControls;
		this.isModal = ( args.isModal !== undefined ) ? args.isModal : this.isModal;
		this.id = args.id;
		this.templateId = args.templateId;

		this.init();
	}

	/**
	 * 
	 */
	init()
	{
		this.onDocumentClick = this.onDocumentClick.bind( this );
		this.onButtonCloseClick = this.onButtonCloseClick.bind( this );
	}

	/**
	 * 
	 * @param {HTMLElement} targetElement
	 */
	create( targetElement = null )
	{
		const template = document.querySelector( `#${this.templateId}` );

		if ( ! template )
		{
			console.error( "WMUWCPopin | Unable to find the popin template in the current document.", this.templateId );
			return;
		}

		this.wrapperElement = template.content.firstElementChild.cloneNode( true );
		this.contentElement = this.wrapperElement.querySelector( this.contentSelector );
		this.modalElement = this.wrapperElement.querySelector( this.modalSelector );
		this.popinElement = this.wrapperElement.querySelector( this.popinSelector );
		this.loadingContentElement = this.wrapperElement.querySelector( this.loadingContentSelector );

		if ( ! this.wrapperElement || ! this.contentElement || ! this.modalElement || ! this.popinElement )
		{
			console.error(
				"WMUWCPopin | Unable to find the popin needed elements in the template.",
				this.wrapperElement,
				this.contentElement,
				this.modalElement,
				this.popinElement
			);
			return;
		}
		
		this.wrapperElement.classList.add( 'is-modal', 'is-init' );
		this.wrapperElement.setAttribute( 'id', this.id );
		this.wrapperElement.setAttribute( 'data-display-mode', this.displayMode );

		if ( false === this.enableGlobalControls )
		{
			this.wrapperElement.setAttribute( 'no-controls', '' );
		}

		this.initButtonClose();

		if ( targetElement )
		{
			targetElement.appendChild( this.wrapperElement );
		}

		this.isCreated = true;
	}

	/**
	 * 
	 */
	open()
	{
		if ( false === this.isCreated )
		{
			/**
			 * @todo Faire fonctionner le default target element autrement à terme
			 */
			this.create( document.body );
			/**
			 * Test de délai post création pour voir si ça nous permet d'éviter certains comportements CSS
			 * innapropriés
			 */
			window.setTimeout( () => this.open(), 50 );
			return;
		}

		if ( true === this.isOpen )
		{
			return;
		}
		
		this.wrapperElement.classList.remove( 'is-closed' );
		this.wrapperElement.classList.add( 'is-opened' );
		this.isOpen = true;

		window.dispatchEvent( new CustomEvent( 'wmuwc/popinOpen', {
			detail: {
				popin: this,
			}
		} ) );
		
		document.addEventListener( 'click', this.onDocumentClick, { capture: true } );
	}

	/**
	 * 
	 */
	close()
	{
		if ( false === this.isOpen )
		{
			return;
		}
		
		this.wrapperElement.classList.remove( 'is-opened' );
		this.wrapperElement.classList.add( 'is-closed' );
		this.isOpen = false;

		window.dispatchEvent( new CustomEvent( 'wmuwc/popinClose', {
			detail: {
				popin: this,
			}
		} ) );

		document.removeEventListener( 'click', this.onDocumentClick, { capture: true } );
	}

	/**
	 * 
	 * @param {HTMLElement} contextElement 
	 */
	initButtonClose( contextElement = null )
	{
		if ( null === contextElement )
		{
			contextElement = this.wrapperElement;
		}

		contextElement.querySelectorAll( this.buttonCloseSelector ).forEach( ( buttonElement ) =>
		{
			if ( true !== buttonElement.wmuwcClosePopinInit )
			{
				buttonElement.addEventListener( 'click', this.onButtonCloseClick );
				buttonElement.wmuwcClosePopinInit = true;
			}
		} );
	}

	/**
	 * 
	 * @param {Event} event
	 */
	onButtonCloseClick( event )
	{
		event.preventDefault();
		this.close();
		return false;
	}
	
	/**
	 * 
	 * @param {Event} event 
	 */
	onDocumentClick( event )
	{
		if ( ! this.closeOnClickOutside || ! this.isOpen )
		{
			return;
		}

		if ( event && event.target && event.target.closest )
		{
			if ( this.popinElement === event.target.closest( this.popinSelector ) )
			{
				return;
			}
		}

		this.close();
	}

	/**
	 * 
	 * @param {String} loadingContent 
	 */
	startLoading( loadingContent = '' )
	{
		this.isLoading = true;
		this.wrapperElement.classList.add( this.loadingClass );

		if ( this.loadingContentElement )
		{
			this.loadingContentElement.innerHTML = loadingContent;

			if ( loadingContent )
			{
				this.wrapperElement.classList.add( 'has-loading-content' );
			}
			else
			{
				this.wrapperElement.classList.remove( 'has-loading-content' );
			}
		}

		window.dispatchEvent( new CustomEvent( 'wmuwc/popinStartLoading', {
			detail: {
				popin: this,
			}
		} ) );
	}

	/**
	 * 
	 */
	endLoading()
	{
		this.isLoading = false;
		this.wrapperElement.classList.remove( this.loadingClass );

		window.dispatchEvent( new CustomEvent( 'wmuwc/popinEndLoading', {
			detail: {
				popin: this,
			}
		} ) );
	}

	/**
	 * 
	 */
	clearContent()
	{
		this.contentElement.innerHTML = '';
		
		window.dispatchEvent( new CustomEvent( 'wmuwc/popinClearContent', {
			detail: {
				popin: this,
			}
		} ) );
	}

	/**
	 * 
	 */
	getContent()
	{
		/**
		 * Pour le moment retourne de manière brute le contenu de contentElement
		 */
		return this.contentElement.innerHTML;
	}

	/**
	 * 
	 * @param {String} content
	 */
	setContent( content )
	{
		this.contentElement.innerHTML = content;
		this.initButtonClose( this.contentElement );

		window.dispatchEvent( new CustomEvent( 'wmu/newElements', {
			detail: {
				elements: [ this.contentElement ],
				from: this,
			}
		} ) );

		window.dispatchEvent( new CustomEvent( 'wmuwc/popinSetContent', {
			detail: {
				popin: this,
				content: content,
			}
		} ) );
	}

}

export default WMUWCPopin;